<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Header - Title -->
      <d-col col sm="4" class="text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{
          $t("dashboard.title")
        }}</span>
        <h3 class="page-title">{{ $t("dashboard.sub") }}</h3>
      </d-col>
      <!-- Create New Campaign button -->
      <d-link to="/new-campaign" class="ml-auto">
        <d-button
          :disabled="disableNewCampaignButton"
          size="md"
          class="btn btn-accent outline mt-2 ml-3 btn-primary btn-padding-fix"
        >
          <i class="material-icons">&#XE145;</i>
          {{ $t("campaigns.createnew") }}
        </d-button>
      </d-link>
      <!-- Page Header - PAGE SELECTOR -->
      <!-- <d-col col sm="4" class="d-flex align-items-center">
        <d-button-group size="small" class="d-inline-flex mb-3 mb-sm-0 mx-auto">
          <d-link tag="button" class="btn btn-white" :to="{ name: 'analytics' }">Traffic</d-link>
          <d-link tag="button" class="btn btn-white" :to="{ name: 'ecommerce' }">Sales</d-link>
        </d-button-group>
      </d-col>-->

      <!-- Page Header - Datepicker -->
      <!-- <d-col sm="8" class="d-flex ml-auto">
        <d-input-group size="sm" class="d-flex justify-content-end my-auto date-range">
          <d-datepicker
            v-model="dateRange.from"
            :highlighted="{ from: dateRange.from, to: dateRange.to || new Date() }"
            typeable
            placeholder="Start date"
            small
          />
          <d-datepicker
            v-model="dateRange.to"
            :highlighted="{ from: dateRange.from, to: dateRange.to || new Date() }"
            typeable
            placeholder="End date"
            small
          />
          <d-input-group-text slot="append">
            <i class="material-icons">&#xE916;</i>
          </d-input-group-text>
        </d-input-group>
      </d-col>-->
    </d-row>

    <!-- Small Stats Blocks -->
    <d-row>
      <d-col md="6" lg="3" class="mb-4">
        <small-stats
          :label="$t('dashboard.sent')"
          :value="getCampaignStats.sent"
        />
      </d-col>
      <d-col md="6" lg="3" class="mb-4">
        <small-stats
          :label="$t('dashboard.opens')"
          :value="getCampaignStats.open"
        />
      </d-col>
      <d-col md="6" lg="3" class="mb-4">
        <small-stats
          :label="$t('dashboard.clicks')"
          :value="getCampaignStats.click"
        />
      </d-col>
      <!-- 
      <d-col md="6" lg="3" class="mb-4">
        <small-stats
          :chart-data="stats.datasets"
          :label="stats.label"
          :value="stats.value"
          :percentage="stats.percentage"
          :increase="stats.increase"
          :decrease="stats.decrease"
          :openRate="openRate"
          :clickRate="clickRate"
          :sentPercentage="sentPercentage"
          :showIncrease="showIncrease"
        />
      </d-col>
      <d-col md="6" lg="3" class="mb-4">
        <small-stats
          :id="`small-stats-${idx}`"
          :chart-data="stats.datasets"
          :label="stats.label"
          :value="stats.value"
          :percentage="stats.percentage"
          :increase="stats.increase"
          :decrease="stats.decrease"
          :openRate="openRate"
          :clickRate="clickRate"
          :sentPercentage="sentPercentage"
          :showIncrease="showIncrease"
        />
      </d-col>
      -->
    </d-row>

    <d-row>
      <!-- Opens -->
      <d-col lg="12" md="12" sm="12" class="mb-4">
        <ao-sessions />
      </d-col>

      <!-- Users by Device -->
      <!-- <d-col lg="4" md="6" sm="6" class="mb-4">
        <ao-users-by-device/>
      </d-col>-->

      <!-- Top Templates -->
      <!-- <d-col lg="5" sm="12" class="mb-4">
        <ao-top-templates />
      </d-col> -->

      <!-- Campaigns' Progress -->
      <!-- <d-col lg="7" sm="12" class="mb-4">
        <ao-campaign-progress />
      </d-col> -->

      <!-- Users by Country -->
      <!-- <d-col lg="4" class="mb-4">
        <country-reports/>
      </d-col>-->
    </d-row>
  </d-container>
</template>

<script>
import SmallStats from "@/components/common/SmallStats.vue";
import TopTemplates from "@/components/common/TopTemplates.vue";
import Sessions from "@/components/analytics/Sessions.vue";
import CampaignProgress from "@/components/analytics/CampaignTracking/CampaignProgress.vue";
// // import UsersByDevice from "@/components/analytics/UsersByDevice.vue";
// import CountryReports from "@/components/common/CountryReports.vue";

import colors from "@/utils/colors";

import { mapGetters } from "vuex";
import { CAMPAIGN_GET_STATS } from "@/store/types";

export default {
  name: "analytics",
  components: {
    SmallStats,
    aoSessions: Sessions,
    aoTopTemplates: TopTemplates,
    aoCampaignProgress: CampaignProgress
    // aoUsersByDevice: UsersByDevice,
    // CountryReports,
  },
  mounted() {
    this.$store.dispatch(CAMPAIGN_GET_STATS).then(resp => {
      console.log(resp);
    });

    // Instantiates new Shepherd tour
    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        classes: "shadow-md bg-purple-dark",
        scrollTo: true
      }
    });
  },
  data() {
    return {
      showIncrease: true,
      openRate: 35,
      clickRate: 22,
      sentPercentage: 100,
      dateRange: {
        from: null,
        to: null
      }
    };
  },
  computed: {
    ...mapGetters([
      "getCampaigns",
      "isCampaignLoading",
      "getCurrentUser",
      "getCampaignStats"
    ])
  }
};
</script>
